"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorLayerSource_OgcFilterAllStrategy = void 0;
var VectorLayerSource_Base_1 = require("./VectorLayerSource_Base");
var Vector_1 = require("ol/source/Vector");
var olLoadingstrategy = require("ol/loadingstrategy");
var VectorLayerSource_OgcFilterAllStrategy = /** @class */ (function (_super) {
    __extends(VectorLayerSource_OgcFilterAllStrategy, _super);
    function VectorLayerSource_OgcFilterAllStrategy(_map, _layer, _url, _logger, _featureLoader, _featureAdd, _urlParams) {
        var _this = _super.call(this, _map, _layer, _url, _featureLoader, _featureAdd, null, _logger) || this;
        _this._urlParams = _urlParams;
        _this.init = function () {
            var self = _this;
            self._filters = self._map.filters;
            self.source = new Vector_1.default({
                loader: function (extent, resolution, projection) {
                    self.loader(extent, resolution, projection, self._map.options.dataProjection, self._layer, self._map.getZoom(), self._url, self._urlParams);
                },
                strategy: olLoadingstrategy.all
            });
        };
        _this.loader = function (extent, resolution, displayProjection, dataProjection, vectorLayer, zoomLevel, url, urlParams) {
            if (urlParams === void 0) { urlParams = null; }
            var self = _this;
            //loading
            self.onLoading();
            var filterStr = self._filters.OgcFilter.getFeatureRequestWithFilter(vectorLayer.group.filterOptions, null, dataProjection, {
                srsName: dataProjection,
                featureNS: '',
                featurePrefix: '',
                featureTypes: [self._layer.layerName],
                outputFormat: "geojson",
                maxFeatures: self.maxFeatureCount
            });
            if (urlParams !== null) {
                url += "/?";
                for (var p in urlParams) {
                    url += p + "=" + urlParams[p] + "&";
                }
            }
            $.ajax({
                url: url,
                method: "POST",
                dataType: "json",
                contentType: "text/xml",
                data: filterStr
            })
                .done(function (data) {
                var dataBounds = self.featureLoader.load(self, self.featureAdd, data, dataProjection, displayProjection.getCode(), resolution, self._logger);
                self.onLoaded((data.features.length >= self.maxFeatureCount), data.features.length, dataBounds, true);
            })
                .fail(function (jqXHR, textStatus, errorThrown) {
                self.onLoaded(false, 0, null, false);
            });
        };
        _this.init();
        return _this;
    }
    return VectorLayerSource_OgcFilterAllStrategy;
}(VectorLayerSource_Base_1.VectorLayerSource_Base));
exports.VectorLayerSource_OgcFilterAllStrategy = VectorLayerSource_OgcFilterAllStrategy;
//# sourceMappingURL=VectorLayerSource_OgcFilterAllStrategy.js.map